export const homePageConstants = {
  RECENTLY_VIEWED: "Recently Viewed By You",
  NEED_TODAY: "Need it Today?",
  TIME_LEFT_TODAY_DELIVERY: "Time Left for Today’s Delivery",
  FIND_GIFTS_NOW: "Find Gifts Now",
  CUSTOM_HERO_BANNER: "custom_hero_banners",
  PERSONALIZED_SQUARICLE_ICON: "personalized-squaricle-icon",
  SMART_BUY: "gift-rewards-lp",
  ALPHA_NATIVE_ICONS: "alpha-native-icons",
};
